const initialState = {
  isLoading: false,
  content: [],
  totalElements: 0,
  error: undefined,
};

export default initialState;
